
export function setTrainers (state, payload) {
    state.trainers = payload
}

export function setSearchTerm(state, payload) {
    state.searchTerm = payload
}

export function setActiveWorkout(state, payload) {
    state.activeWorkout = payload
}

export function setUser (state, payload) {
    state.user = payload
}

export function setFavourites (state, payload) {
    state.favourites = payload
}

export function setRegistrationUser (state, payload) {
    let data = {};
    const defaults = {
        preferences: {
            workoutInterval: 3,
            workoutTimeOfDay: "20:00",
            workoutDuration: 5400
        }
    };

    // add missing properties
    payload.goalId = payload.goal ? payload.goal.id : '';
    payload.interestsIds = payload.interests ? payload.interests.map(interest => interest.id) : [];

    // set defaults
    if(payload.preferences) {
        if(!payload.preferences.workoutInterval) {
            payload.preferences.workoutInterval = defaults.preferences.workoutInterval;
        }
        if(!payload.preferences.workoutTimeOfDay) {
            payload.preferences.workoutTimeOfDay = defaults.preferences.workoutTimeOfDay;
        }
        if(!payload.preferences.workoutDuration) {
            payload.preferences.workoutDuration = defaults.preferences.workoutDuration;
        }
    } else {
        payload.preferences = defaults.preferences;
    }

    // read only the properties that are editable in the registration form and defined in the state
    for (var key of Object.keys(state.registrationUser)) {
        if(payload[key] !== undefined) {
            data[key] = payload[key];
        }
    }
    state.registrationUser = {...state.registrationUser, ...data};
}

export function setRegistrationUserGoal(state, payload) {
    state.registrationUser.goalId = payload
}

export function setRegistrationUserInterests(state, payload) {
    state.registrationUser.interestsIds = payload
}

export function setRegistrationUserDOB(state, payload) {
    state.registrationUser.dob = payload
}

export function setRegistrationUserProfileImageKey(state, payload) {
    state.registrationUser.profileImageKey = payload
}

export function setRegistrationUserWeight(state, payload) {
    state.registrationUser.weight = payload
}

export function setRegistrationUserHeight(state, payload) {
    state.registrationUser.height = payload
}

export function setMobileNav(state, payload) {
    state.isMobileNav = payload
}

export function setNotebook(state, payload) {
    state.isNotebook = payload
}

export function setFilters(state, payload) {
    state.filters = payload
}

export function removeFilterOfType(state, payload) {
    if(Array.isArray(state.filters[payload.type])) {
        let filterObjectIndex = state.filters[payload.type].findIndex(obj => obj.id === payload.id);
        state.filters[payload.type].splice(filterObjectIndex, 1);
    } else if(state.filters[payload.type].id !== undefined) {
        state.filters[payload.type] = {};
    }
}

export function removeAllFilters(state, payload) {
    state.filters.levels = [];
    state.filters.goals = [];
    state.filters.interests = [];
    state.filters.duration = {};
    state.filters.trainers = [];
}

export function setGoals(state, payload) {
    state.goals = payload;
}

export function setInterests(state, payload) {
    state.interests = payload;
}

export function setReasons(state, payload) {
    state.reasons = payload;
}